import { useAbility } from "./useAbility.jsx";

export function useBookingPermissions() {
  const { can } = useAbility();
  const domain = "booking";

  return {
    canViewAny: () => can(domain, "viewAny"),
    canExportAny: () => can(domain, "exportAny"),
  };
}
